import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static values = { text: String, copied: String }
  static targets = [ "button" ]

  connect() {
    this.tooltip = new Tooltip(this.buttonTarget, {
      title: this.copiedValue,
      trigger: "manual"
    })
  }

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      this.tooltip.show()
      setTimeout(() => this.tooltip.hide(), 1000)
    })
  }
}
